import { IEntityConversationCreateModel } from '../../../interfaces/Report/IReport';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useCreateEntityConversationMutation = (onError?: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (newConvo: IEntityConversationCreateModel) => {
            const response = await zoneApiClient.createEntityConversation(newConvo);

            if (!response?.httpResponse.ok) {
                if (response.errorMessage && response.httpResponse.status == 400) {
                    if (response.errors !== undefined && response.errors[0] !== undefined) {
                        throw new Error(
                            `Failed to create Conversation : ${response.errors[0].message}`
                        );
                    }
                }
                throw new Error('Failed to create Conversation');
            }
            return response.payload;
        },
        onError(error) {
            if (error instanceof Error && typeof onError === 'function') {
                onError(error.message);
            }
        },
    });
}
    